<template>
  <div>
    <Head title="Gestão de Paciente" />
    <div class="shadow_box rounded-lg p-6">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Gestão de Paciente</h1>
      <data-table
        v-if="loadTable"
        :query='{ "date_last_appointment": selectedDate }'
        search-label="Pesquisar por nome, e-mail ou CPF"
        v-model:columns="columns"
        route="patients/list"
        no-data-label="Nenhum paciente cadastrado"
        no-result-label="Nenhum paciente encontrado"
      >
        <template #table.cell.content.patient_status="{ value, row }">
          <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" />
        </template>
        <template #grid.content.body.patient_status="{ value, row }">
          <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" />
        </template>

        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-grid gap-4" :class="{'grid-cols-2': user.role == 1, 'grid-cols-1': user.role == 2}">
            <Link v-if="user.role == 2" :href="'patients/detail/' + row.id" ><font-awesome-icon icon="fa-eye" class="text-green-600 text-lg cursor-pointer" /></Link>
            <span v-if="user.role == 1" @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-primary text-lg cursor-pointer" /></span>
            <span v-if="user.role == 1" @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
          </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
          <div class="inline-grid gap-4" :class="{'grid-cols-2': user.role == 1, 'grid-cols-1': user.role == 2}">
            <Link v-if="user.role == 2" :href="'patients/detail/' + row.id" ><font-awesome-icon icon="fa-eye" class="text-green-600 text-lg cursor-pointer" /></Link>
            <span v-if="user.role == 1" @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-primary text-lg cursor-pointer" /></span>
            <span v-if="user.role == 1" @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
          </div>
        </template>

        <template #table.cell.content.patient_link="{ value, row }">
          <Link :href="'/patients/detail/' + row.id" class="btn-primary font-normal text-xs px-4 py-2.5">Ver paciente<font-awesome-icon icon="fa-chevron-right" class="ml-2" /></Link>
        </template>

        <template #grid.content.body.patient_link="{ value, row }">
          <Link :href="'/patients/detail/' + row.id" class="btn-primary font-normal text-xs px-4 py-2.5">Ver paciente<font-awesome-icon icon="fa-chevron-right" class="ml-2" /></Link>
        </template>
      </data-table>
    </div>
    <modal-delete v-if="user.role == 1" ref="modalDelete" @confirm="reloadTable"></modal-delete>
    <modal-edit v-if="user.role == 1" :modal-scrollable="true" ref="modalEdit" title="Paciente" url="patients" @submitForm="reloadTable" :item="{user: {}, errors: {user: {}}}" :multipart="true">
      <template #form="{item}">
        <text-input v-model="item.user.name" :error="item.errors[`user.name`]" class="lg:pr-6 w-full lg:w-1/2" label="Nome" />
        <text-input v-model="item.user.email" :error="item.errors[`user.email`]" class="mt-6 lg:mt-0 w-full lg:w-1/2" label="E-mail" />
        <mask-input v-model="item.cpf" mask="###.###.###-##" :error="item.errors.cpf" class="lg:pr-6 mt-6 w-full lg:w-1/2" label="CPF" />
        <date-input v-model="item.birthdate" :error="item.errors.birthdate" class="mt-6 w-full lg:w-1/2" label="Data de nascimento" />
        <phone-input v-model="item.address.phone" :error="item.errors[`address.phone`]" class="lg:pr-6 mt-6 w-full lg:w-1/2" label="Telefone" />
        <select-input v-model="item.sex" :error="item.errors.sex" class="mt-6 w-full lg:w-1/2" label="Gênero">
          <option :value="null" />
          <option v-for="(value, name, index) in sex_options" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <cep-input @updateAddress="onUpdateAddress" v-model="item.address.postcode" :error="item.errors[`address.postcode`]" class="mt-6 lg:pr-6 w-full lg:w-2/6" label="CEP" />
        <text-input v-model="item.address.street" :error="item.errors[`address.street`]" class="mt-6 lg:pr-6 w-full lg:w-3/6" label="Logradouro" />
        <text-input v-model="item.address.number" :error="item.errors[`address.number`]" class="mt-6 w-full lg:w-1/6" label="Número" />
        <text-input v-model="item.address.complement" :error="item.errors[`address.complement`]" class="mt-6 w-full" label="Complemento" />
        <text-input v-model="item.address.neighborhood" :error="item.errors[`address.neighborhood`]" class="mt-6 lg:pr-6 w-full lg:w-1/3" label="Bairro" />
        <text-input v-model="item.address.city" :error="item.errors[`address.city`]" class="mt-6 lg:pr-6 w-full lg:w-1/3" label="Cidade" />
        <select-input v-model="item.address.state" :error="item.errors[`address.state`]" class="mt-6 w-full lg:w-1/3" label="Estado">
          <option :value="null" />
          <option v-for="(value, name, index) in states_options" :key="name" :value="name">{{ value }}</option>
        </select-input>
      </template>
    </modal-edit>
    <modal-update-photo-profile ref="modalUpdatePhotoProfile" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout/Layout'
import LoadingButton from '@/Shared/Components/LoadingButton'
import ModalDelete from '@/Shared/Modal/ModalDelete'
import ModalEdit from '@/Shared/Modal/ModalEdit'
import DataTable from '@/Shared/Components/DataTable'
import SwitchInput from '@/Shared/Fields/SwitchInput'
import TextInput from '@/Shared/Fields/TextInput'
import PasswordInput from '@/Shared/Fields/PasswordInput'
import MaskInput from '@/Shared/Fields/MaskInput'
import SelectInput from '@/Shared/Fields/SelectInput'
import PhotoInput from '@/Shared/Fields/PhotoInput'
import DateInput from '@/Shared/Fields/DateInput'
import PhoneInput from '@/Shared/Fields/PhoneInput'
import CepInput from '@/Shared/Fields/CepInput'
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import ModalUpdatePhotoProfile from '@/Shared/Modal/ModalUpdatePhotoProfile'

export default {

  props: {
    sex_options: Object,
    states_options: Object,
  },
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    DataTable,
    SwitchInput,
    TextInput,
    PasswordInput,
    MaskInput,
    SelectInput,
    PhotoInput,
    DateInput,
    PhoneInput,
    CepInput,
    Link,
    ModalUpdatePhotoProfile,
  },
  layout: Layout,
  mounted() {
    if(this.user.professional){
      if(!this.user.photo) {
        this.$refs.modalUpdatePhotoProfile.openModalUpdatePhotoProfile();
      }
    }

  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  data() {
    return {
      selectedDate: null,
      groups: [],
      loadTable: true,
      columns: [
        {
          uniqid: 'patient_name',
          label: 'Nome',
          field: 'users.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.user?.name ?? ''
        },
        {
          uniqid: 'patient_cpf',
          label: 'CPF',
          field: 'cpf',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.cpf ? row.cpf : ''
        },
        {
          uniqid: 'patient_birthdate',
          label: 'Data de nascimento',
          field: 'birthdate',
          visible: this.user.role == 1,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => new Date( val.split( '-' ) ).toLocaleDateString( 'pt-BR' ),
        },
        {
          uniqid: 'patient_email',
          label: 'E-mail',
          field: 'users.email',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.user?.email ?? ''
        },
        {
          uniqid: 'patient_phone',
          label: 'Telefone',
          field: 'addresses.phone',
          visible: this.user.role == 1,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.address && row.address.phone ? row.address.phone : ''
        },
        {
          uniqid: 'patient_sex',
          label: 'Gênero',
          field: 'sex',
          visible: this.user.role == 1,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.sex_label ? row.sex_label : ''
        },
        {
          uniqid: 'patient_state',
          label: 'Estado',
          field: 'addresses.state',
          visible: this.user.role == 1,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.address.state ? row.address.state : ''
        },
        {
          uniqid: 'patient_b2b',
          label: 'Tipo',
          field: 'b2b',
          visible: true,
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.b2b ? 'B2B' : 'B2C'
        },
        {
          uniqid: 'patient_city',
          label: 'Cidade',
          field: 'addresses.city',
          visible: this.user.role == 1,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.address.city ? row.address.city : ''
        },
        {
          uniqid: 'patient_street',
          label: 'Endereço',
          field: 'addresses.street',
          visible: this.user.role == 1,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => (row.address.street ? row.address.street + ', ' : '') + (row.address.number ? row.address.number + ' - ' : '') + (row.address.neighborhood ? row.address.neighborhood : '')
        },
        {
          uniqid: 'patient_phone',
          label: 'Telefone',
          field: 'addresses.phone',
          visible: this.user.role == 2,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.address.phone ? row.address.phone : ''
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: this.user.role == 1,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
        {
          uniqid: 'patient_link',
          label: 'Estado de saúde',
          field: 'id',
          visible: this.user.role == 2,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    changeStatus(item) {
      item.status = !item.status;
      this.$inertia.post("/patients/update-status", {id: item.id, status: item.status});
    },
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/patients/${item.id}`, `Deseja realmente excluir o paciente ${item.user.name}?`);
    },
    openModalEdit(i) {
      let item = {
        id: i.id,
        sex: i.sex ?? '',
        birthdate: i.birthdate ?? '',
        cpf: i.cpf ?? '',
        address: i.address ?? '',
        notification_app: i.notification_app ?? true,
        notification_email: i.notification_email ?? true,
        status: i.status ?? true,
        user: {},
      }
      if(i.user) {
        item.user = {
          id: i.user.id,
          name: i.user.name,
          email: i.user.email,
          photo: {
            name: i.user.photo?.name,
            size: i.user.photo?.size,
            url: i.user.photo?.url,
          },
        }
      }
      this.$refs.modalEdit.openModalEdit(item);
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    onUpdateAddress(json) {
      this.$refs.modalEdit.item.address.city = json.localidade;
      this.$refs.modalEdit.item.address.state = json.uf;
      this.$refs.modalEdit.item.address.street = json.logradouro;
      this.$refs.modalEdit.item.address.neighborhood = json.bairro;
    },
    openModalUpdatePhotoProfile() {
      this.$refs.modalUpdatePhotoProfile.openModalUpdatePhotoProfile();
    },
  },
}
</script>
